import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NotificationListModule } from '@portal-core/notifications/components/notification-list/notification-list.module';
import { ReviewPackageNotificationListComponent } from './review-package-notification-list.component';

@NgModule({
  declarations: [ReviewPackageNotificationListComponent],
  exports: [ReviewPackageNotificationListComponent],
  imports: [CommonModule, NotificationListModule, MatButtonModule, MatProgressBarModule]
})
export class ReviewPackageNotificationListModule { }
